<template>
  <div class="main-page">
    <section class="page-section">
      <div class="container">
        <div class="grid">
          <div class="col-12 md:col-12 sm:col-12 comp-grid">
            <div>
              <form
                ref="observer"
                tag="form"
                @submit.prevent="startSaveRecord()"
                @reset="resetForm"
              >
                <div>
                  <table class="p-datatable-table" style="width: 100%">
                    <tbody>
                      <tr
                        v-for="(formData, row) in arrFormData"
                        :key="row"
                        class="input-row"
                      >
                        <div class="card nice-shadow-6 mx-2">
                          <div class="grid">
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">Label *</div>

                              <div class="">
                                <!-- <div class="field mb-0"> -->
                                <InputText
                                  ref="ctrllabel"
                                  v-model.trim="formData.label"
                                  label="Label"
                                  type="text"
                                  placeholder="Label"
                                  pattern="^[A-Za-z- ]+$"
                                  class="w-full"
                                  :class="getErrorClass(row, 'label')"
                                >
                                </InputText>
                                <!-- </div> -->
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Data Type *
                              </div>

                              <div class="">
                                <!-- <div class="field mb-0"> -->
                                <Dropdown
                                  class="w-full"
                                  ref="ctrldatatype"
                                  optionLabel="label"
                                  optionValue="value"
                                  v-model="formData.datatype"
                                  :options="$menus.datatypeItems"
                                  label="Data Type"
                                  placeholder="Select ..."
                                  :class="getErrorClass(row, 'datatype')"
                                >
                                </Dropdown>
                                <!-- </div> -->
                              </div>
                            </div>

                            <div
                              v-if="
                                formData.datatype == radio ||
                                formData.datatype == dropdown
                              "
                              class="col-12"
                            >
                              <div class="mb-2 font-bold text-sm">
                                Enter Input Options *
                              </div>

                              <div class="mb-2">
                                <!-- <div class="field mb-0"> -->
                                <Chips
                                  :class="getErrorClass(row, 'options')"
                                  class="w-full"
                                  inputClass="w-full"
                                  ref="ctrloptions"
                                  :allowDuplicate="false"
                                  v-model="formData.options"
                                  hint="Tip: Hit the 'Enter' key after entering each input option"
                                />
                                <!-- </div> -->
                                <small
                                  >Tip: Hit the <span class="font-bold text-primary">Enter</span>  key after entering each
                                  input option</small
                                >
                              </div>
                            
                            </div>
                          </div>
                            <!-- <hr /> -->
                        </div>
                        <th>
                          <Button
                            class="p-button-text p-button-danger p-button-rounded p-button-sm"
                            v-if="arrFormData.length >= minRowCount"
                            @click="removeFormRow(row)"
                            icon="pi pi-times"
                          />
                        </th>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="100" class="">
                          <Button
                            v-if="arrFormData.length < maxRowCount"
                            @click="addFormRow()"
                            icon="pi pi-plus"
                            label="Add New"
                            class="p-button-success p-button-outlined p-button-rounded p-button-sm"
                          />
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </form>
              <slot :submit="submit" :saving="saving"></slot>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { PageMixin } from "../../mixins/page.js";
import { AddPageMixin } from "../../mixins/addpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import {
  helpers,
  required,
  requiredIf,
  email,
  minLength,
  maxLength,
  minValue,
  maxValue,
  numeric,
  integer,
  decimal,
  ipAddress,
} from "@vuelidate/validators";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "grantadditionalinfoPage",
  components: {},
  mixins: [PageMixin, AddPageMixin],
  props: {
    pageName: {
      type: String,
      default: "grant_additional_info",
    },
    maxRowCount: {
      type: Number,
      default: 10,
    },
    minRowCount: {
      type: Number,
      default: 1,
    },
    additionalformdefinition: { type: String, default: "[]" },
  },
  data() {
    return {
      arrFormData: [
        // {
        //   label: "",
        //   datatype: "",
        //   options: [],
        //   value: "",
        // },
      ],
      radio: "Radio",
      dropdown: "Dropdown",
    };
  },
  validations() {
    let arrFormData = {
      $each: helpers.forEach({
        label: { required },
        datatype: { required },
        value: {},
        options: {
          required: requiredIf(() => {
            const esit =
              this.arrFormData.datatype == this.radio ||
              this.arrFormData.datatype == this.dropdown;
            return esit;
          }),
        },
      }),
    };
    return { arrFormData };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Add Grant Additional Info";
      },
    },
  },
  methods: {
    ...mapActions("exam_sittings", ["saveRecord"]),
    async startSaveRecord() {
      this.submitted = true;
      const isFormValid = await this.v$.$validate();
      if (!isFormValid) {
        let errors = this.v$.arrFormData.$each.$response.$errors;
        this.flashMsg("Form is invalid", "", "error");
        return;
      }
      this.saving = true;
      let payload = this.normalizedFormData();
      let url = this.apiUrl;
      let data = { url, payload };
      this.saveRecord(data).then(
        (response) => {
          this.saving = false;
          this.resetForm();
          this.closeDialogs(); // close page dialog that if opened
          this.flashMsg(this.msgAfterSave);
          this.$emit("submitted", this.record);
        },
        (response) => {
          this.saving = false;
          this.showPageRequestError(response);
        }
      );
    },
    getAdditionalFormDefinition() {
      if (this.additionalformdefinition) {
        this.arrFormData = JSON.parse(this.additionalformdefinition);
      }
    },
    addFormRow() {
      let newFormData = {
        label: "",
        datatype: "",
        options: [],
        value: "",
      };
      this.arrFormData.push(newFormData);
    },
    removeFormRow(index) {
      this.arrFormData.splice(index, 1);
    },
    resetForm() {
      this.arrFormData = [
        {
          label: "",
          datatype: "",
          options: [],
          value: "",
        },
      ];
      this.updateFormData();
    },
    getErrorClass(row, field) {
      let errors = this.v$.arrFormData.$each.$response.$errors[row][field];
      return { "p-invalid": errors.length && this.submitted };
    },
  },
  watch: {},
  async mounted() {
    this.getAdditionalFormDefinition();
  },
  async created() {},
};
</script>
<style scoped>
.p-chips .p-component .p-inputwrapper,
.p-inputtext .p-chips-multiple-container {
  width: 100% !important;
}
</style>
